import React from 'react';
import './Shimmer.css';

const Shimmer = ({ type }) => {
    const shimmerClass = `shimmer-wrapper ${type}`;

    if (type === 'home') {
        return (
            <div className="container shimmer-home">
                <div className="shimmer-wrapper shimmer-hero"></div>
                <div className="shimmer-grid">
                    {[1, 2, 3, 4, 5, 6].map((i) => (
                        <div key={i} className="shimmer-wrapper shimmer-item"></div>
                    ))}
                </div>
            </div>
        );
    }

    return <div className={shimmerClass}></div>;
};

export default Shimmer;
